define([], function() {
var applepay = {
		paymentRequest:null,
		showApplePaySection: function() {
	      $('input[id=appliedPayMethod]').val('');
	      $('#save_CC').prop('checked', false);
	      $('#radio-credit-card').prop('checked', false);
	      $('#radio-applepay').prop('checked', true);
	      COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), false);
	      $('[data-payment-type-element="true"]').each(function() {
	    	  this.setAttribute("aria-checked", "false");
	      });
	      $('#radio-applepay-ada-handler').attr('aria-checked', true);
	      
	      $('#cc-payment-block').addClass('hide');
	      $('#cc-payment-address-block').addClass('hide'); 
	      $('#address-container-billing').addClass('hide');
	      $('#wallet-edit-link').addClass('hide');
	      $('#clickpay-payment-block').addClass('hide');
	      $('#applepay-payment-block').removeClass('hide');
	      if($('#checkOutStepNumber').val() == '3'){
	        	$('#place-order-button-applepay').removeClass('hide');
	        	$('#place-order-button-regular').addClass('hide');
	         }   
	      // Remove error messages if wallet section is deselected.
	      COSTCO.wallet.hideErrorBox();
	      COSTCO.wallet.hideErrorMessage(); 
	      
	      if(COSTCO.Checkout.displayAllPayments()){
	    	  $('#clicktopay-block-form').addClass('hide');
	          $('#wallet-payment-address-block').addClass('hide');
	      }
	    },
	    isApplePaySelected: function() {
			return $('#applepay-block input[name=\'payment-radio\']').is(':checked');
		},
		isApplePayApplied: function() {
	    	return ($('input[id=appliedPayMethod]').length > 0 && $('input[id=appliedPayMethod]').val() == 'applepay');
		},
		isApplePayUsed: function() {
		   	return ($('#applepay-info-container').length > 0 && !$('#applepay-info-container').hasClass('hide'));
		},
		submit : {
		   applePayForm : function() {
			$('.order-ajax').addClass('ajax-busy');
			var form = COSTCO.applepay.forms.applePayForm();
			form.submit();
		   },
		},
		forms : {
			applePayForm : function() { return $('#ApplePayPaymentForm')},
		},
		 /**
	     * Copies the attributes from CheckoutReviewForm into the CheckoutPaymentForm 
	     * if the 'change' link has been clicked in the review page
	     */
	    prepareApplePayPaymentFormForOrderSubmit: function(){
			if($("#ApplePayPaymentForm input[name=selDeliveryDate]").length){
				$("#ApplePayPaymentForm input[name=selDeliveryDate]").val($("#CheckoutReviewForm input[name=selDeliveryDate]").val());
			}
			if($("#ApplePayPaymentForm input[name=orderShipmodeId]").length){
				$("#ApplePayPaymentForm input[name=orderShipmodeId]").val($("#CheckoutReviewForm input[name=orderShipmodeId]").val());
			}
			$("#ApplePayPaymentForm input[name=deviceId]").val($("#CheckoutReviewForm input[name=deviceId]").val());
			$("#ApplePayPaymentForm input[name=setAsDefaultShippingAddress]").val($("#CheckoutReviewForm input[name=setAsDefaultShippingAddress]").val());
			$("#ApplePayPaymentForm input[name=doBillingPaymentCmd]").val('true');
			$("#ApplePayPaymentForm").attr("action", $("#CheckoutReviewForm").attr("action"));
	    },
	    renderPaymentSheet: function() {
	    	let form = applepay.forms.applePayForm();
	    	$.ajax({
                url: '/GetApplePayOrderInfo?orderId='+$(form).find('input[name=orderId]').val()+'&storeId='+wcs.storeId+'&langId='+wcs.langId+'&catalogId='+wcs.catalogId,
                type: 'GET',
                data: '',
                dataType: 'json',
                async:false,
                success: function (data) {
                	applepay.paymentRequest = data;
                },
                error: function (data) {
                   console.log('error calling GetApplePayOrderInfo '+data);
                },
            });
	    	
	    	var session = new ApplePaySession(applepay_version, applepay.paymentRequest);
	    	session.begin();

	    	session.onvalidatemerchant = function (event) {
	    		console.log(event.validationURL);
	 	    	if(event.validationURL.indexOf("cn-apple-pay-gateway") > 0){
	 	  			$('#applepay_not_supported').removeClass('hide');
	 	  			$('#applepay-payment-block').addClass('hide');
	 	  			$('#place-order-button-applepay').addClass('hide');
	 	  			window.digitalDataEvents = window.digitalDataEvents || [];
	 	  			digitalDataEvents.push({uimsg:"Checkout | Apple Pay not available in your Region" });
	 	  			session.abort();
	 	    	} else {
		    		$.ajax({
		                url: '/ApplePayMerchantValidation?&validationURL='+event.validationURL,
		                type: 'POST',
		                data: '',
		                dataType: 'json',
		                success: function (data) {
		                	session.completeMerchantValidation(JSON.parse(data.merchantSession));
		                },
		                error: function (data) {
		                	session.abort();
		                    console.log('error calling ApplePayAjaxMerchantValidation');
		                },
			          });
	 	    	}
	    	}

	    	session.onpaymentmethodselected = function(event) {
	    		session.completePaymentMethodSelection(applepay.paymentRequest.total, applepay.paymentRequest.lineItems);
	    	}

	    	session.onpaymentauthorized = function(event) {
	    		console.log('Apple Pay Payment Authorized');
	    		let regex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
	    		let billingContact = event.payment.shippingContact.phoneNumber;
	    		
	    		let result;
	    		let invalid_phone_message = {
	    		        SYSTEM: messages.ERR_APPLEPAY_PAYMENTSHEET_INVALID_PHONENUMBER,
	    		      };
	    		if(!regex.test(billingContact)){
	    			let errors =  new ApplePayError("shippingContactInvalid","phoneNumber",invalid_phone_message.SYSTEM);
	    			result = {
			    	        "status": ApplePaySession.STATUS_FAILURE,
			    	        "errors": [errors]
			    	    };
	    			session.completePayment(result);
	    		} else {
	    			var paymentDataString = JSON.stringify(event.payment.token.paymentData);
		    		$("#ApplePayPaymentForm input[name=paymentToken]").val(btoa(paymentDataString));
		    		$("#ApplePayPaymentForm input[name=displayName]").val(event.payment.token.paymentMethod.displayName);
		    		$("#ApplePayPaymentForm input[name=ap_cc_brand]").val(event.payment.token.paymentMethod.network);
		    		$("#ApplePayPaymentForm input[name=ap_paymentType]").val(event.payment.token.paymentMethod.type);
		    		$("#ApplePayPaymentForm input[name=transactionId]").val(event.payment.token.transactionIdentifier);
		    		$("#ApplePayPaymentForm input[name=billingAddress]").val(JSON.stringify(event.payment.billingContact));
		    		$("#ApplePayPaymentForm input[name=billingPhoneNumber]").val(event.payment.shippingContact.phoneNumber);
		    		
		    		result = {
		    	        "status": ApplePaySession.STATUS_SUCCESS
		    	    };
		    		session.completePayment(result);
		    		applepay.submit.applePayForm();
	    		}
	    	}

	    	session.oncancel = function (event) {
	    		console.log("Cancelled Apple Pay Payment ");
	    	}
	    	
	    },
	    sendPaymentToken: function (payment) {
	    	console.log('sendPaymentToken');
	    }
	};

   
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = {};
	} 
    window.COSTCO.applepay = applepay;
    return applepay;
});



// WEBPACK FOOTER //
// ./js/checkout/applepay.js